export default "__VITE_ASSET__DBQ1Dx5B__ 640w, __VITE_ASSET__C1SkxMW8__ 1024w, __VITE_ASSET__Pv3jl8AP__ 1536w";